const minimist = require('minimist');

let argv = {};
if (process.argv) {
  argv = minimist(process.argv.slice(2));
}

const cliOpts = {
  stubbed: !!argv.stubbed,
  console: !!argv.console,
};

module.exports = cliOpts;
